import DateFormat from "%/dynamic-component-editor/options/date-format";
import dayjs from "dayjs";
import { timeAgo } from "%/dynamic-component-editor/helpers/dayjs-helper";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";

export const DateElementMixin = {
  options: [DateFormat],
  data() {
    return {
      DateFormat,
    };
  },
  computed: {
    ...mapState(useConfigurationStore, ["dateFormat"]),
  },
  methods: {
    dayjs,
    timeAgo,
    formattedDate(date) {
      const dayjsDate = dayjs.unix(date);
      let formatString = this.getOptionValue(DateFormat);
      if (formatString === "global") {
        // Studio doesn't run the publication-configuration boot path,
        // so `configuration-store.dateFormat` returns undefined until
        // a destination is fully hydrated. Fall back to a readable
        // default so date-bearing event/show/etc. previews render
        // instead of crashing the canvas on `undefined.value`.
        formatString = this.dateFormat?.value ?? "MMM D, YYYY";
      }
      if (formatString === "timeAgo") {
        return this.timeAgo(date);
      }
      return dayjsDate.format(formatString);
    },
  },
};
